import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const FileIcon: React.FC<AddIconProps> = ({ size = 22, color = '#C8D2E1', className, onClick }) => (
  <svg width="44" height="50" viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4203_76322)">
      <path d="M11.25 0.9375H28.0322L43.3125 16.0156V45C43.3125 47.2437 41.4937 49.0625 39.25 49.0625H11.25C9.00634 49.0625 7.1875 47.2437 7.1875 45V5C7.1875 2.75634 9.00634 0.9375 11.25 0.9375Z" fill="white" stroke={color} strokeWidth="1.875" />
      <path d="M27.5 1.25V12.5C27.5 14.5711 29.1789 16.25 31.25 16.25H42.5" stroke={color} strokeWidth="1.875" strokeLinecap="round" />
    </g>
    <rect y="23.6543" width="31.25" height="20" rx="2.5" fill="#292D32" />
    <path d="M4.00937 38.1543V29.0634H10.0285V30.6481H5.93142V32.8143H9.62904V34.399H5.93142V38.1543H4.00937ZM12.9934 29.0634V38.1543H11.0714V29.0634H12.9934ZM14.3248 38.1543V29.0634H16.2468V36.5696H20.1442V38.1543H14.3248ZM21.1671 38.1543V29.0634H27.2928V30.6481H23.0891V32.8143H26.9776V34.399H23.0891V36.5696H27.3105V38.1543H21.1671Z" fill="white" />
    <defs>
      <clipPath id="clip0_4203_76322">
        <rect width="37.5" height="50" fill="white" transform="translate(6.25)" />
      </clipPath>
    </defs>
  </svg>

);

export default FileIcon;

